import { FC } from 'react'
import StyledButton, { StyledButtonProps } from '@organs/StyledButton'
import ButtonStyle from '@enums/ButtonStyle'
import { ArrowRightOutlined } from '@ant-design/icons'

const NextButton: FC<StyledButtonProps> = ({
  buttonStyle = ButtonStyle.GRAY,
  children = 'Вперед',
  ...restProps
}) => {
  return (
    <StyledButton
      buttonStyle={buttonStyle}
      {...restProps}
      rightIcon={<ArrowRightOutlined />}
    >
      {children}
    </StyledButton>
  )
}

export default NextButton
